<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ក ៥.ខ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.គ ៥.ឃ ៥.ង
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ច
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ឆ​ ៥.ជ
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <schoolarea :data="fac_5a" :title="title[1]" />            
            <emisbuilding
              :data="fac_5b"
              :title="title[2]"              
            />
          </div>
          <div>
            <p>            
              <schoolroom :data="fac_5cc" :title="title[3]" />
            </p>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <schoolFac :data="fac_5c" :title="title[4]" />
            <handwashing :data="uti_5e" :lastRow="0" :title="title[5]" />
            <!-- LastRow is 0 for pre school only -->
          </div>
          <div>
            <p></p>
            <toilet :data="uti_5f" :title="title[6]" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <water :data="uti_5g" :title="title[7]" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <facility :data1="uti_5h1" :data2="uti_5h2" :title="title[8]" />            
            <preextoy :data="uti_5d" :title="title[9]" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import schoolArea from "@/components/privateascf/sharedCom/compreSchoolArea.vue";
import emis_building from "@/components/ascf/sharedCom/emis_building.vue";
import schoolRoom from "@/components/privateascf/sharedCom/privSchoolRoom.vue";
import schoolFac from "@/components/privateascf/sharedCom/privSchoolFacility.vue";
import handWashing from "@/components/ascf/sharedCom/handwashing.vue";
import toilet from "@/components/ascf/sharedCom/toilet.vue";
import WaterSource from "@/components/ascf/sharedCom/waterSource.vue";
import Facility from "@/components/ascf/sharedCom/facility.vue";
import preExternalToy from "@/components/ascf/pre/preExternalToy.vue";

export default {
  props: [
    "title",
    "fac_5a",
    "fac_5b",
    "fac_5c",
    "fac_5cc",
    "uti_5d",
    "uti_5e",
    "uti_5f",
    "uti_5g",
    "uti_5h1",
    "uti_5h2",
  ],
  components: {
    schoolarea: schoolArea,
    emisbuilding: emis_building,    
    schoolroom: schoolRoom,
    schoolFac: schoolFac,
    handwashing: handWashing,
    toilet: toilet,
    water: WaterSource,
    facility: Facility,
    preextoy: preExternalToy,
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  methods: {},
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>